import React, { useState } from "react";
import Logo from "../../atoms/Logo";
import { Link, useNavigate } from "react-router-dom";
import { TopNavigationProps } from "./types";
import styled, { useTheme } from "styled-components";
import PointsIcon from "../../../assets/icons/PointsIcon";
import { Pathnames } from "../BottomNavigation";
import Button from "../../atoms/Button";
import { useMutation } from "@tanstack/react-query";
import { supabase } from "../../../lib/api";
import { QueryKeys } from "../../../services/types";

const TopNavigation = ({ session }: TopNavigationProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const theme = useTheme();

  const navigate = useNavigate();

  const { mutateAsync: signOutMutation } = useMutation({
    mutationFn: () => supabase.auth.signOut(),
    mutationKey: [QueryKeys.SESSION],
  });

  return (
    <StyledTopNavigation>
      <Logo large isBeta />

      <StyledUsernameAndPoints
        onClick={() => setIsModalOpen((isOpen) => !isOpen)}
      >
        <b>{session?.user?.user_metadata?.username}</b>
        <span>
          <PointsIcon color={theme.colors.primary} />
          {session?.user?.user_metadata?.points || 0}
        </span>
      </StyledUsernameAndPoints>

      {isModalOpen && (
        <>
          <StyledModal isDisabled={"settings"}>
            <ul>
              <li>
                <Link to={Pathnames.SETTINGS}>Settings</Link>
              </li>
              <li>
                <Button
                  text="Log out"
                  onClick={() => signOutMutation()}
                  backgroundColor="transparent"
                  padding="0"
                  color={theme.colors.error}
                  withHover={false}
                />
              </li>
            </ul>
          </StyledModal>
          <StyledBackdrop onClick={() => setIsModalOpen(false)} />
        </>
      )}
    </StyledTopNavigation>
  );
};

const StyledTopNavigation = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  max-width: 1200px;
  margin: auto;
  position: relative;
`;

const StyledUsernameAndPoints = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  cursor: pointer;

  span {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 3px;
    color: ${({ theme }) => theme.colors.primary};
  }
`;

const StyledModal = styled.div<{ isDisabled?: string }>`
  position: absolute;
  bottom: -110px;
  right: 0;
  z-index: 1000;
  background-color: ${({ theme }) => theme.colors.text};
  padding: 0 20px;
  border-radius: ${({ theme }) => theme.radii.default};

  ul {
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;

    li {
      padding: 5px;
      a {
        color: ${({ theme }) => theme.colors.dark};
        text-decoration: none;

        ${({ isDisabled, theme }) =>
          isDisabled === "settings" &&
          `
          cursor: not-allowed;  
          pointer-events: none;
          opacity: 0.3;
        `}
      }
    }
  }
`;

const StyledBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.1;
  z-index: 999;
`;

export default TopNavigation;
